import CheckCircleIcon from '@atlaskit/icon/glyph/check-circle';
import ErrorIcon from '@atlaskit/icon/glyph/error';
import InfoIcon from '@atlaskit/icon/glyph/info';
import WarningIcon from '@atlaskit/icon/glyph/warning';
export var typesMapping = {
  connectivity: {
    icon: WarningIcon,
    defaultLabel: 'connectivity inline message'
  },
  confirmation: {
    icon: CheckCircleIcon,
    defaultLabel: 'confirmation inline message'
  },
  info: {
    icon: InfoIcon,
    defaultLabel: 'info inline message'
  },
  warning: {
    icon: WarningIcon,
    defaultLabel: 'warning inline message'
  },
  error: {
    icon: ErrorIcon,
    defaultLabel: 'error inline message'
  }
};
export var VAR_SECONDARY_TEXT_COLOR = '--secondary-text-color';